module.exports = __webpack_public_path__ + "static/img/TEST1.7056ffaa.png";